module.exports = __webpack_public_path__ + "static/assets/b69fffc6cba7efc136e36e05a438bde5.svg";